import {ReactNode, useRef} from "react";
import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

import {useClickOutside} from "../../../../hooks/handle_click_outside";
import {SearchDropdownArrow} from "../../../../search/components/atoms/SearchDropdownArrow";
import {SortOptionsValues} from "../../types/SortOptionsValues";

interface IProps {
    children: ReactNode;
    isDropdownOpen: boolean;
    setDropdownOpen: (setIsOpen: boolean) => void;
    isMobile: boolean;
    setDesktopFilterBlendActive?: (isOpen: boolean) => void;
    rightDropdown?: boolean;
    disableClearAction?: boolean;
    currentValue: SortOptionsValues;
    sortOptions: {label: string; value: number; slug?: string}[];
    setCurrentValue: (value: number) => void;
    dropdownShadow?: boolean;
    closeOnOutsideClick?: boolean;
    onOpen?: () => void;
    onRemove?: () => void;
    onClear?: () => void;
}
export const Sort = (props: IProps) => {
    const {
        children,
        isDropdownOpen,
        setDropdownOpen,
        isMobile,
        setDesktopFilterBlendActive,
        rightDropdown,
        disableClearAction,
        currentValue,
        sortOptions,
        setCurrentValue,
        dropdownShadow,
        closeOnOutsideClick,
        onOpen,
        onRemove,
        onClear: onClearProp
    } = props;

    const wrapperRef = useRef(null);
    const isSorted = currentValue !== SortOptionsValues.NOT_SELECTED;

    const handleClick = () => {
        const isOpening = !isDropdownOpen;

        setDropdownOpen(isOpening);
        setDesktopFilterBlendActive && setDesktopFilterBlendActive(isOpening);

        if (isOpening && !isMobile && onOpen) {
            onOpen();
        }
    };

    const onClear = (event: React.MouseEvent | React.KeyboardEvent) => {
        event.stopPropagation();

        if (onClearProp) {
            onClearProp();
        } else {
            setCurrentValue && setCurrentValue(SortOptionsValues.NOT_SELECTED);
            setDesktopFilterBlendActive && setDesktopFilterBlendActive(false);
        }

        if (!isMobile && onRemove) {
            onRemove();
        }
    };

    const getSortLabel = (value: number) => {
        return sortOptions.filter((el) => el.value === value)?.[0]?.label || "";
    };

    useClickOutside(wrapperRef, () => closeOnOutsideClick && setDropdownOpen(false));

    return (
        <div className={filterHolderClass} ref={wrapperRef}>
            <div tabIndex={-1} className={filterLabelClass} onClick={handleClick} data-testid={NAVIGATION_TEST_IDS.SORT_BUTTON}>
                <Text variant="body_copy_2" className={filterLabelTextClass}>
                    Sortuj
                    {isSorted && (
                        <>
                            <br />
                            <Text variant="info_txt_2" as="span" className={subLabel}>
                                {getSortLabel(currentValue)}
                            </Text>
                        </>
                    )}
                </Text>

                {isSorted && !disableClearAction ? (
                    <button type="button" onClick={(event) => onClear(event)}>
                        <CloseIcon size="2" />
                    </button>
                ) : (
                    <SearchDropdownArrow isDown={isDropdownOpen} />
                )}
            </div>

            {isDropdownOpen && (
                <DropdownHolder rightDropdown={rightDropdown} dropdownShadow={dropdownShadow}>
                    <Text variant="body_copy_1">Sortuj</Text>
                    {children}
                </DropdownHolder>
            )}
        </div>
    );
};

interface IDropdownHolderProps {
    rightDropdown?: boolean;
    dropdownShadow?: boolean;
    children: ReactNode;
}

const DropdownHolder = ({rightDropdown, dropdownShadow, children}: IDropdownHolderProps) => {
    const dropdownClass = css({
        background: "var(--colors-white)",
        padding: "1.6rem 0.8rem",

        md: {
            position: "absolute",
            top: "6rem",
            zIndex: 1001,
            minWidth: "36rem",
            maxHeight: "60rem",
            padding: "2.4rem 3.2rem 1.6rem 3.2rem",
            borderRadius: 4,
            right: rightDropdown ? 0 : "initial",
            boxShadow: dropdownShadow ? "var(--shadow-1)" : "none"
        }
    });

    return <div className={dropdownClass}>{children}</div>;
};

const filterHolderClass = css({
    position: "relative",
    width: "100%",

    md: {
        padding: 0,
        "&:focus": {
            outline: "none",
            boxShadow: "none"
        }
    }
});

const filterLabelClass = css({
    display: "none",

    "&:focus": {
        outline: "none"
    },

    md: {
        padding: "0 1.5rem",
        height: "4.8rem",
        cursor: "pointer",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%"
    }
});

const filterLabelTextClass = css({
    fontSize: "1.4rem",
    paddingRight: "1rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
});

const subLabel = css({
    color: "var(--colors-gray-700)"
});
import {ReactNode, useRef} from "react";
import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

import {useClickOutside} from "../../../../hooks/handle_click_outside";
import {SearchDropdownArrow} from "../../../../search/components/atoms/SearchDropdownArrow";
import {SortOptionsValues} from "../../types/SortOptionsValues";

interface IProps {
    children: ReactNode;
    isDropdownOpen: boolean;
    setDropdownOpen: (setIsOpen: boolean) => void;
    isMobile: boolean;
    setDesktopFilterBlendActive?: (isOpen: boolean) => void;
    rightDropdown?: boolean;
    disableClearAction?: boolean;
    currentValue: SortOptionsValues;
    sortOptions: {label: string; value: number; slug?: string}[];
    setCurrentValue: (value: number) => void;
    dropdownShadow?: boolean;
    closeOnOutsideClick?: boolean;
    onOpen?: () => void;
    onRemove?: () => void;
    onClear?: () => void;
}
export const Sort = (props: IProps) => {
    const {
        children,
        isDropdownOpen,
        setDropdownOpen,
        isMobile,
        setDesktopFilterBlendActive,
        rightDropdown,
        disableClearAction,
        currentValue,
        sortOptions,
        setCurrentValue,
        dropdownShadow,
        closeOnOutsideClick,
        onOpen,
        onRemove,
        onClear: onClearProp
    } = props;

    const wrapperRef = useRef(null);
    const isSorted = currentValue !== SortOptionsValues.NOT_SELECTED;

    const handleClick = () => {
        const isOpening = !isDropdownOpen;

        setDropdownOpen(isOpening);
        setDesktopFilterBlendActive && setDesktopFilterBlendActive(isOpening);

        if (isOpening && !isMobile && onOpen) {
            onOpen();
        }
    };

    const onClear = (event: React.MouseEvent | React.KeyboardEvent) => {
        event.stopPropagation();

        if (onClearProp) {
            onClearProp();
        } else {
            setCurrentValue && setCurrentValue(SortOptionsValues.NOT_SELECTED);
            setDesktopFilterBlendActive && setDesktopFilterBlendActive(false);
        }

        if (!isMobile && onRemove) {
            onRemove();
        }
    };

    const getSortLabel = (value: number) => {
        return sortOptions.filter((el) => el.value === value)?.[0]?.label || "";
    };

    useClickOutside(wrapperRef, () => closeOnOutsideClick && setDropdownOpen(false));

    return (
        <div className={filterHolderClass} ref={wrapperRef}>
            <div tabIndex={-1} className={filterLabelClass} onClick={handleClick} data-testid={NAVIGATION_TEST_IDS.SORT_BUTTON}>
                <Text variant="body_copy_2" className={filterLabelTextClass}>
                    Sortuj
                    {isSorted && (
                        <>
                            <br />
                            <Text variant="info_txt_2" as="span" className={subLabel}>
                                {getSortLabel(currentValue)}
                            </Text>
                        </>
                    )}
                </Text>

                {isSorted && !disableClearAction ? (
                    <button type="button" onClick={(event) => onClear(event)}>
                        <CloseIcon size="2" />
                    </button>
                ) : (
                    <SearchDropdownArrow isDown={isDropdownOpen} />
                )}
            </div>

            {isDropdownOpen && (
                <DropdownHolder rightDropdown={rightDropdown} dropdownShadow={dropdownShadow}>
                    <Text variant="body_copy_1">Sortuj</Text>
                    {children}
                </DropdownHolder>
            )}
        </div>
    );
};

interface IDropdownHolderProps {
    rightDropdown?: boolean;
    dropdownShadow?: boolean;
    children: ReactNode;
}

const DropdownHolder = ({rightDropdown, dropdownShadow, children}: IDropdownHolderProps) => {
    const dropdownClass = css({
        background: "var(--colors-white)",
        padding: "1.6rem 0.8rem",

        md: {
            position: "absolute",
            top: "6rem",
            zIndex: 1001,
            minWidth: "36rem",
            maxHeight: "60rem",
            padding: "2.4rem 3.2rem 1.6rem 3.2rem",
            borderRadius: 4,
            right: rightDropdown ? 0 : "initial",
            boxShadow: dropdownShadow ? "var(--shadow-1)" : "none"
        }
    });

    return <div className={dropdownClass}>{children}</div>;
};

const filterHolderClass = css({
    position: "relative",
    width: "100%",

    md: {
        padding: 0,
        "&:focus": {
            outline: "none",
            boxShadow: "none"
        }
    }
});

const filterLabelClass = css({
    display: "none",

    "&:focus": {
        outline: "none"
    },

    md: {
        padding: "0 1.5rem",
        height: "4.8rem",
        cursor: "pointer",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%"
    }
});

const filterLabelTextClass = css({
    fontSize: "1.4rem",
    paddingRight: "1rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
});

const subLabel = css({
    color: "var(--colors-gray-700)"
});
